/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suspended',
  templateUrl: './suspended.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class SuspendedComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  private initView() {
  }
}



// WEBPACK FOOTER //
// ./client/app/suspended/suspended.component.ts